import React, {lazy, Suspense} from 'react'
import t from 'format-message'
import {useParams} from 'react-router'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'

const Moderate = lazy(() =>
  import('./components/pages/Moderate').then(({Moderate}) => ({default: Moderate})),
)

const ModerateSession = lazy(() =>
  import('./components/pages/ModerateSession').then(({ModerateSession}) => ({
    default: ModerateSession,
  })),
)

export function ModeratePage() {
  const {activeAssignmentId} = useParams()

  useDocumentTitle(t('Moderate'))

  return (
    <Suspense>
      <Moderate activeAssignmentId={activeAssignmentId} />
    </Suspense>
  )
}

export function ModerateSessionPage() {
  const {activeAssignmentId, quizSessionId} = useParams()

  useDocumentTitle(t('Moderate'))

  return (
    <Suspense>
      <ModerateSession
        activeAssignmentId={activeAssignmentId}
        quizSessionId={quizSessionId}
        renderBackLink={true}
      />
    </Suspense>
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the moderation module.
 */
export const moderationRoutes = [
  {
    index: true,
    element: <ModeratePage />,
  },
  {
    path: 'session/:quizSessionId',
    element: <ModerateSessionPage />,
  },
]
